import axios from 'axios';
import { useState } from 'react';

export default function App() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [popupVisible, setPopupVisible] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) return;

    setError('');

    try {
      await axios.post(
        'https://api.brevo.com/v3/contacts',
        { email: email.trim(), listIds: [4] },
        {
          headers: {
            'api-key':
              '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',
          },
        }
      );

      setPopupVisible(true);
      setEmail('');
      setTimeout(() => setPopupVisible(false), 3000);
    } catch (error) {
      setError('Something went wrong. Please try again.');
    }
  };

  return (
    <div className='flex flex-col items-center justify-center min-h-screen bg-black text-center text-white pt-14 gap-[40px] md:gap-[48px]'>
      <img src='/oc-logo.png' alt='Logo' className='w-[180px] h-[18px]' />

      <div className='flex flex-col items-center gap-1 px-4'>
        <p className='height text-xl/[1.4] md:text-[32px]/[1.4] font-medium font-clash '>
          Site under construction
        </p>
        <h1 className='text-5xl/[1.1] md:text-8xl/[1.1] font-bold font-clash mb-6'>
          COMING SOON!
        </h1>
      </div>

      <img
        src='/maintenance.png'
        alt='Coming Soon'
        className='w-full max-w-[774px] h-[380px] md:h-[440px] object-cover rounded-lg'
      />

      <div className='flex flex-col items-center gap-6  px-4'>
        <p className='text-lg md:text-2xl font-medium font-clash '>
          Leave your email to get notified when the shop will be launched
        </p>

        <div className='flex flex-col place-items-start'>
          <form
            onSubmit={handleSubmit}
            className={`flex flex-row md:flex-row gap-0 border-[1px] rounded-[0.6rem] ${
              error
                ? 'border-oc-red'
                : !email
                ? 'border-oc-disabled'
                : 'border-oc-bronze'
            }`}
          >
            <input
              type='email'
              required
              value={email}
              onChange={(e) => {
                if (error) setError('');
                setEmail(e.target.value);
              }}
              placeholder='Enter your email'
              className={`p-3 w-full md:w-64 bg-black text-white rounded-l-lg rounded-r-none focus:outline-none ${
                error
                  ? 'border-oc-red'
                  : !email
                  ? 'border-oc-disabled'
                  : 'border-oc-bronze'
              }`}
            />
            <button
              type='submit'
              className={`px-6 py-3 rounded-r-lg rounded-l-none font-clash text-nowrap ${
                error
                  ? 'bg-oc-red hover:bg-oc-red-dark'
                  : !email
                  ? 'bg-oc-disabled hover:bg-oc-grey-dark'
                  : 'bg-oc-bronze hover:bg-oc-bronze-dark'
              }
              ${!email ? 'text-oc-grey-text' : 'text-white'}
              `}
            >
              Notify me
            </button>
          </form>
          {error && <p className='text-oc-red text-sm'>{error}</p>}
        </div>
      </div>

      <footer
        className='flex justify-between w-full text-gray-600 text-sm md:px-20 px-10 py-6 text-white text-nowrap md:flex-row flex-col border-t-oc-grey border-t-[1px]
gap-5     md:mt-auto mt-auto '
      >
        <p>© {new Date().getFullYear()}, Owners Club</p>
        <div className='flex gap-4 justify-between'>
          <a
            href='https://www.instagram.com/ownrs_club/'
            target='_blank'
            rel='noopener noreferrer'
            className='hover:text-oc-bronze hover:no-underline'
          >
            Instagram
          </a>
          <a
            href='https://www.youtube.com/@Ownersclubwear'
            target='_blank'
            rel='noopener noreferrer'
            className='hover:text-oc-bronze hover:no-underline'
          >
            YouTube
          </a>
          <a
            href='https://www.tiktok.com/@ownrs_club'
            target='_blank'
            rel='noopener noreferrer'
            className='hover:text-oc-bronze hover:no-underline'
          >
            TikTok
          </a>
        </div>
      </footer>

      {popupVisible && (
        <div className='fixed bottom-5 left-1/2 transform -translate-x-1/2'>
          <div className=' bg-green-500 text-white px-4 py-3 rounded-lg animate-slide-in text-nowrap'>
            ✅ Email submitted successfully!
          </div>
        </div>
      )}

      <style>
        {`
          @keyframes slide-in {
            from {
              transform: translateY(100%);
              opacity: 0;
            }
            to {
              transform: translateY(0);
              opacity: 1;
            }
          }
          .animate-slide-in {
            animation: slide-in 0.3s ease-out;
          }
        `}
      </style>
    </div>
  );
}
